import React from "react";

function Footer() {
    return (
        <div>
            <footer>
                <p>2025 Ashley Williams</p>
            </footer>
        </div>
    );
}

export default Footer;